import { useState, useEffect } from 'react';
import { throttleToAnimationFrame } from '@utils/common';

function useHasOverflow(ref) {
  const [hasOverflow, setHasOverflow] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  useEffect(() => {
    const target = ref.current;
    if (!target) {
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      setHasOverflow(target.scrollWidth > target.clientWidth);
    });
    const onScroll = throttleToAnimationFrame(() => {
      setCanScrollLeft(target.scrollLeft > 25);
      setCanScrollRight(target.scrollLeft + target.clientWidth < target.scrollWidth - 25);
    });
    onScroll();
    target.addEventListener("scroll", onScroll);
    resizeObserver.observe(target);
    setTimeout(() => {
      onScroll();
    }, 50);
    return () => {
      target.removeEventListener("scroll", onScroll);
      resizeObserver.disconnect();
    };
  }, [ref]);
  return [hasOverflow, {
    canScrollLeft,
    canScrollRight
  }];
}

export { useHasOverflow };
//# sourceMappingURL=has-overflow.js.map
